import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import { Button } from '@ipc/ipc-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { deleteRfidFileRequestActionCreator } from '../redux/actions/RfidFileDeleteActions';
import { getCheckedRows } from '../../redux/selectors/RfidUploadedFilesListSelectors';

class RfidFileDeleteDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.row.row.id,
    };
    this.confirmDelete = this.confirmDelete.bind(this);
  }

  confirmDelete() {
    const ids = [];
    if (this.props.checkedRows !== undefined && this.props.checkedRows.length !== 0) {
      this.props.checkedRows.map((row) => ids.push(row.id));
      this.props.deleteRfidFileRequestActionCreator(
        ids,
      );
    } else {
      this.props.deleteRfidFileRequestActionCreator(
        [this.state.id],
      );
    }
    this.props.closeDialog();
  }

  render() {
    return (
      <Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" open={this.props.openDialog}>
        <DialogTitle id="simple-dialog-title">Delete RFID File</DialogTitle>
        <div>
          <p style={{ padding: '5px' }}>Only files will be deleted, No impact on Balance on Hand will happen. Please confirm.</p>
        </div>
        <div className="after-box">
          <Button style={{ marginLeft: '25px', marginBottom: '10px' }} onClick={this.props.closeDialog}>Cancel</Button>
          <Button
            style={{ float: 'right', marginRight: '50px', marginBottom: '10px' }}
            onClick={this.confirmDelete}
            className="primary-button-false"
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    );
  }
}

RfidFileDeleteDialog.propTypes = {
  row: PropTypes.arrayOf(PropTypes.object),
  deleteRfidFileRequestActionCreator: PropTypes.func,
  checkedRows: PropTypes.arrayOf(PropTypes.object),
  openDialog: PropTypes.func.isRequired,
  closeDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    checkedRows: getCheckedRows(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  deleteRfidFileRequestActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RfidFileDeleteDialog);
